import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import './EmaSelector.css';

import { setEma_1, setEma_2, setIntervalSelected } from '../pages/slices/emaSelectionSlicer';

const EmaSelector = () => {
  const [emaSelected, setEmaSelected] = useState(null);
  const [intervalIdxSelected, setIntervalIdxSelected] = useState(null);
  const [blink, setBlink] = useState('');
  const { selectedSymbol } = useSelector(state => state.streamCryptoInfo);
  // const { intervalSelected } = useSelector(state => state.emaSelection);
  const dispatch = useDispatch();

  const handleEmaClick = (index) => {
    if (selectedSymbol !== '') { // Prevent click if disabled
      setEmaSelected(index);

      switch(index) {
        case 0:
          dispatch(setEma_1(7));
          dispatch(setEma_2(14));
          break;
        case 1:
          dispatch(setEma_1(9));
          dispatch(setEma_2(21));
          break;
        case 2:
          dispatch(setEma_1(12));
          dispatch(setEma_2(50));
          break;
        case 3:
          dispatch(setEma_1(50));
          dispatch(setEma_2(200));
          break;
        default:          
      }
    }
  };

  const handleIntervalClick = (index) => {
    if (selectedSymbol !== '') { // Prevent click if disabled
      setIntervalIdxSelected(index);      
      switch(index) {
        case 0:
          dispatch(setIntervalSelected('1h'));
          break;
        case 1:
          dispatch(setIntervalSelected('4h'));
          break;
        case 2:
          dispatch(setIntervalSelected('1d'));
          break;
        case 3:
          dispatch(setIntervalSelected('W'));
          break;
        default:
      }
    }
  };

  const triggerBlink = () => {
    setBlink(''); // Clear the class to reset the animation
    setTimeout(() => {
      setBlink('blinking'); // Set the class again to re-trigger the animation
    }, 0);
  };

  useEffect(() => {
    dispatch(setEma_1(0));
    dispatch(setEma_2(0));
    dispatch(setIntervalSelected(''));
    setEmaSelected(null);
    setIntervalIdxSelected(null);
    triggerBlink();
  }, [selectedSymbol, dispatch]);

  const divStyle = {
    display: 'inline-block',
    width: '80px',
    height: '30px',
    borderRadius: '8px',
    border: '1px solid grey',
    marginRight: '10px',
    textAlign: 'center',
    lineHeight: '30px',
    cursor: 'pointer',
    color: 'antiquewhite',
    fontFamily: 'sans-serif',
    transition: 'background-color 0.3s ease'
  };

  const selectedStyle = {
    color: '#26ff00',
    border: '2px solid #26ff00'
  };

  const containerStyle = {
    display: 'flex',
    justifyContent: 'space-around',
    alignItems: 'center',
    height: '50px' // Adjust as needed for vertical centering
  };

  const containerIntervalStyle = {
    display: 'flex',
    justifyContent: 'space-around',
    marginBottom: '5px'
  };

  const disabledStyle = {
    cursor: 'not-allowed',
    pointerEvents: 'none', // Disable all interactions
    opacity: 0.5, // Make it look disabled
  };

  return (
    <div style={selectedSymbol === '' ? disabledStyle : {}}>
      <div style={containerStyle}>
        {[0, 1, 2, 3].map((index) => (
          <div
            key={index}
            className={blink}
            style={{ ...divStyle, ...(emaSelected === index ? selectedStyle : {}) }}
            onClick={() => handleEmaClick(index)}
          >
            {index === 0 && '7 x 14'}
            {index === 1 && '9 x 21'}
            {index === 2 && '12 x 50'}
            {index === 3 && '50 x 200'}
          </div>          
        ))}
      </div>
      <div style={containerIntervalStyle}>
        {[0, 1, 2, 3].map((index) => (
          <div
          key={index}
          className={blink}
          style={{ ...divStyle, ...(intervalIdxSelected === index ? selectedStyle : {}) }}
          onClick={() => handleIntervalClick(index)}
        >
            {index === 0 && '1 hour'}
            {index === 1 && '4 hours'}
            {index === 2 && '1 day'}
            {index === 3 && '1 week'}
          </div>  
        ))}
      </div>
    </div>
  );
};

export default EmaSelector;